import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoPendo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 129 48"
    {...props}
  >
    <g
      fillRule="evenodd"
      clipPath="url(#Logo_Pendo_svg__a)"
      clipRule="evenodd"
    >
      <path
        fill="#1A2022"
        d="M100.207 31.618c3.299 0 5.982-2.63 5.982-5.863 0-3.232-2.683-5.862-5.982-5.862s-5.983 2.63-5.983 5.862 2.684 5.863 5.983 5.863m5.982-20.432h2.834v23.23h-2.834v-2.32a8.84 8.84 0 0 1-5.982 2.3c-4.861 0-8.816-3.877-8.816-8.64 0-4.765 3.955-8.64 8.816-8.64 2.237 0 4.346.813 5.982 2.299zm-64.758 20.33c3.299 0 5.983-2.63 5.983-5.863S44.73 19.79 41.43 19.79s-5.982 2.63-5.982 5.863 2.684 5.863 5.982 5.863M35.45 19.313a8.84 8.84 0 0 1 5.982-2.3c4.862 0 8.817 3.876 8.817 8.64s-3.955 8.64-8.817 8.64a8.84 8.84 0 0 1-5.982-2.3v8.23h-2.834v-23.23h2.834zm20.206 4.99c.638-2.625 3.015-4.51 5.726-4.51 2.675 0 4.916 1.845 5.514 4.51zm5.726-7.31c-4.789 0-8.684 3.908-8.684 8.711s3.895 8.711 8.684 8.711c2.681 0 5.142-1.007 6.753-2.763l.837-.912.107-.118-.117-.109-1.82-1.678-.117-.109-.108.118-.837.913c-1.067 1.163-2.823 1.858-4.698 1.858-2.711 0-5.088-1.885-5.726-4.51H69.84v-1.4c0-4.886-3.715-8.712-8.458-8.712m64.4 8.711c0 3.26-2.684 5.91-5.983 5.91s-5.982-2.65-5.982-5.91 2.684-5.91 5.982-5.91 5.983 2.65 5.983 5.91m-5.983-8.711c-4.861 0-8.816 3.908-8.816 8.711s3.955 8.711 8.816 8.711 8.817-3.908 8.817-8.71c0-4.804-3.955-8.712-8.817-8.712m-39.428 0c-1.97 0-3.846.75-5.323 2.12v-2.12h-2.759v17.422h2.76v-8.89c0-3.173 2.387-5.753 5.322-5.753s5.323 2.58 5.323 5.752v8.891h2.758v-8.89c0-4.705-3.625-8.532-8.081-8.532"
      />
      <path
        fill="#FF4876"
        d="M.615 27.777h13.333v13.037l13.334-13.037V14.74H13.948z"
      />
    </g>
    <defs>
      <clipPath id="Logo_Pendo_svg__a">
        <path
          fill="#fff"
          d="M.615 0h128v48h-128z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoPendo;
